import { CalculationAddOns, PersonsWith } from '../model/offer';
import { SwitcherStates } from '../component/offer-content/offer-content.component';

const formatApiAddOnsUtil = (
  selectedCustomizeAlcoholIncluded: PersonsWith[] | null,
  selectedCustomizeForTheActiveIncluded: PersonsWith[] | null,
  switcherStates: SwitcherStates,
): CalculationAddOns => {
  const addOns = Object.entries(switcherStates.state).reduce<CalculationAddOns>((acc, [codeName, value]) => {
    acc[codeName] = { selected: value };

    return acc;
  }, {});

  if (selectedCustomizeAlcoholIncluded) {
    addOns['AlcoholIncluded'] = {
      selected: selectedCustomizeAlcoholIncluded.some(({ selected }) => selected),
      specifying: selectedCustomizeAlcoholIncluded,
    };
  }
  if (selectedCustomizeForTheActiveIncluded) {
    addOns['ForTheActive'] = {
      selected: selectedCustomizeForTheActiveIncluded.some(({ selected }) => selected),
      specifying: selectedCustomizeForTheActiveIncluded,
    };
  }

  return addOns;
};

export default formatApiAddOnsUtil;
